module.exports = __webpack_public_path__ + "static/media/home_tunnel_6.ccb3f851.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_tunnel_6.png
// module id = 117
// module chunks = 0